import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getPdfPlanSettings } from '@queries'

const useGetPlanSettings = () => {
  const { projectId } = useParams()

  const { data, isFetching } = useQuery<PdfPlanSettings>({
    queryKey: getPdfPlanSettings.getKey(projectId as string),
    queryFn: () => getPdfPlanSettings.request(projectId as string),
  })

  return { data, isFetching }
}

export default useGetPlanSettings
